<template>
  <div class="box">
    <div class="row g-3 mb-5">
      <h3 class="pb-1">Programm</h3>

      <!-- Gemeinsamer Filter -->
      <div class="filter-section mb-4">
        <Agenda 
          agendatype="filter"
          :show-filter="true"
          :show-dates="true"
          :search-text="searchtext"
          :active-filters="activeFilters"
          @update:search-text="searchtext = $event"
          @update:active-filters="activeFilters = $event"
          class="filter-agenda"
        />
      </div>

      <!-- Bestehenden Timeline-Teil in Desktop-Wrapper packen -->
      <div class="desktop-timeline-view">
        <!-- Tagesübersicht für Montag (Timeline) -->
        <div v-if="showDay1" class="day-section mb-4">
          <h4 class="font-weight-bold pb-3">MONDAY, JULY 7, 2025</h4>

          <!-- Grid für Überschriften (v-show entfernt, iteriert über activeLocations) -->
          <div class="location-header-grid" :style="gridStyle"> 
             <div class="time-header-spacer"></div>
             <!-- Iteriere über AKTIVE Locations -->
             <h5 v-for="location in activeLocations" :key="`h-d1-${location}`">{{ location }}</h5>
             <div class="time-header-spacer"></div>
          </div>

          <!-- Timeline Grid für Inhalte -->
          <div class="timeline-grid" :style="gridStyle"> 
            <!-- Zeitskala links -->
            <div class="timeline">
               <div v-for="time in timeSlotsDay1" :key="`d1-tl-${time}`" class="time-slot">
                 {{ time }}
              </div>
            </div>

            <!-- Location Content Container (iteriert über activeLocations) -->
            <div class="location-columns-container"> 
               <!-- Iteriere über AKTIVE Locations (v-show entfernt) -->
              <div class="location-column" v-for="location in activeLocations" :key="`d1-${location}`">
                <div class="events-container">
                  <!-- NEU: Iteriere über gruppierte Events -->
                  <template v-for="(events, timeKey) in groupedFilteredEventsDay1[location]" :key="`d1-${location}-${timeKey}`">
                    <!-- Fall 1: Nur ein Event zu dieser Zeit -->
                    <AgendaEntry v-if="events.length === 1"
                                :ae="events[0]"
                                agendatype="timeline"
                                :style="getEventStyle(events[0], startHourTimelineDay1)"/>
                    <!-- Fall 2: Mehrere Events -> Accordion (Vue-gesteuert) -->
                    <div v-else 
                         class="accordion timeline-accordion" 
                         :style="getAccordionStyle(events, `accordion-d1-${location}-${String(timeKey).replace(':', '')}` === currentlyOpenAccordionId, startHourTimelineDay1)"
                         :id="`accordion-d1-${location}-${String(timeKey).replace(':', '')}`">
                      <div class="accordion-item">
                        <h2 class="accordion-header" :id="`heading-d1-${location}-${String(timeKey).replace(':', '')}`">
                          <button 
                            class="accordion-button" 
                            :class="{ 'collapsed': currentlyOpenAccordionId !== `accordion-d1-${location}-${String(timeKey).replace(':', '')}` }"
                            type="button" 
                            @click="toggleAccordion(`accordion-d1-${location}-${String(timeKey).replace(':', '')}`)"
                            :aria-expanded="currentlyOpenAccordionId === `accordion-d1-${location}-${String(timeKey).replace(':', '')}`" 
                            :aria-controls="`collapse-d1-${location}-${String(timeKey).replace(':', '')}`">
                            {{ events.length }} Sessions at {{ timeKey }}
                          </button>
                        </h2>
                        <div :id="`collapse-d1-${location}-${String(timeKey).replace(':', '')}`" 
                             class="accordion-collapse collapse"
                             :class="{ 'show': currentlyOpenAccordionId === `accordion-d1-${location}-${String(timeKey).replace(':', '')}` }"
                             :aria-labelledby="`heading-d1-${location}-${String(timeKey).replace(':', '')}`">
                          <div class="accordion-body">
                            <!-- Hier die einzelnen AgendaEntries für die Gruppe rendern -->
                            <AgendaEntry v-for="ae in events" 
                                        :key="`d1-${location}-${timeKey}-${ae.objvalueid}`" 
                                        :ae="ae"
                                        agendatype="accordion-timeline" /> <!-- Neuer agendatype -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <!-- Zeitskala rechts -->
            <div class="timeline">
               <div v-for="time in timeSlotsDay1" :key="`d1-tr-${time}`" class="time-slot">
                 {{ time }}
              </div>
            </div>
          </div>
        </div>
        <!-- Tagesübersicht für Dienstag (Timeline) -->
         <div v-if="showDay2" class="day-section mb-4">
          <h4 class="font-weight-bold pb-3">TUESDAY, JULY 8, 2025</h4>
          
          <!-- Grid für Überschriften (v-show entfernt, iteriert über activeLocations) -->
          <div class="location-header-grid" :style="gridStyle">
             <div class="time-header-spacer"></div>
              <!-- Iteriere über AKTIVE Locations -->
              <h5 v-for="location in activeLocations" :key="`h-d2-${location}`">{{ location }}</h5>
             <div class="time-header-spacer"></div>
          </div>

           <!-- Timeline Grid für Inhalte -->
           <div class="timeline-grid" :style="gridStyle">
             <!-- Zeitskala links -->
            <div class="timeline">
               <div v-for="time in timeSlotsDay2" :key="`d2-tl-${time}`" class="time-slot">
                 {{ time }}
              </div>
            </div>

            <!-- Location Content Container (iteriert über activeLocations) -->
             <div class="location-columns-container">
               <!-- Iteriere über AKTIVE Locations (v-show entfernt) -->
              <div class="location-column" v-for="location in activeLocations" :key="`d2-${location}`">
                <div class="events-container">
                  <!-- NEU: Iteriere über gruppierte Events -->
                   <template v-for="(events, timeKey) in groupedFilteredEventsDay2[location]" :key="`d2-${location}-${timeKey}`">
                    <!-- Fall 1: Nur ein Event zu dieser Zeit -->
                    <AgendaEntry v-if="events.length === 1"
                                :ae="events[0]"
                                agendatype="timeline"
                                :style="getEventStyle(events[0], startHourTimelineDay2)"/>
                    <!-- Fall 2: Mehrere Events -> Accordion (Vue-gesteuert) -->
                    <div v-else 
                         class="accordion timeline-accordion" 
                         :style="getAccordionStyle(events, `accordion-d2-${location}-${String(timeKey).replace(':', '')}` === currentlyOpenAccordionId, startHourTimelineDay2)"
                         :id="`accordion-d2-${location}-${String(timeKey).replace(':', '')}`">
                      <div class="accordion-item">
                        <h2 class="accordion-header" :id="`heading-d2-${location}-${String(timeKey).replace(':', '')}`">
                           <button 
                            class="accordion-button" 
                            :class="{ 'collapsed': currentlyOpenAccordionId !== `accordion-d2-${location}-${String(timeKey).replace(':', '')}` }"
                            type="button" 
                            @click="toggleAccordion(`accordion-d2-${location}-${String(timeKey).replace(':', '')}`)"
                            :aria-expanded="currentlyOpenAccordionId === `accordion-d2-${location}-${String(timeKey).replace(':', '')}`" 
                            :aria-controls="`collapse-d2-${location}-${String(timeKey).replace(':', '')}`">
                            {{ events.length }} Sessions at {{ timeKey }}
                          </button>
                        </h2>
                        <div :id="`collapse-d2-${location}-${String(timeKey).replace(':', '')}`" 
                             class="accordion-collapse collapse" 
                             :class="{ 'show': currentlyOpenAccordionId === `accordion-d2-${location}-${String(timeKey).replace(':', '')}` }"
                             :aria-labelledby="`heading-d2-${location}-${String(timeKey).replace(':', '')}`">
                          <div class="accordion-body">
                            <!-- Hier die einzelnen AgendaEntries für die Gruppe rendern -->
                            <AgendaEntry v-for="ae in events" 
                                        :key="`d2-${location}-${timeKey}-${ae.objvalueid}`" 
                                        :ae="ae"
                                        agendatype="accordion-timeline" /> <!-- Neuer agendatype -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <!-- Zeitskala rechts -->
            <div class="timeline">
               <div v-for="time in timeSlotsDay2" :key="`d2-tr-${time}`" class="time-slot">
                 {{ time }}
              </div>
            </div>
          </div>
        </div>
      </div> <!-- Ende desktop-timeline-view -->

      <!-- NEU: Tablet Listenansicht -->
      <div class="tablet-list-view">
        <!-- Tagesübersicht für Montag (Liste) -->
        <div v-if="showDay1" class="day-section mb-4">
          <h4 class="font-weight-bold pb-3">MONDAY, JULY 7, 2025</h4>
          <div class="row g-3">
            <!-- Iteriere über flache Liste für Tag 1 -->
            <AgendaEntry v-for="ae in filteredListDay1" 
                         :key="`list-d1-${ae.objvalueid}`" 
                         :ae="ae"
                         agendatype="list" 
                         class="col-md-6"/> <!-- Beispiel: 2 Spalten auf Tablet -->
             <p v-if="filteredListDay1.length === 0" class="text-muted">No events found for this day based on current filters.</p>
          </div>
        </div>
        <!-- Tagesübersicht für Dienstag (Liste) -->
         <div v-if="showDay2" class="day-section mb-4">
          <h4 class="font-weight-bold pb-3">TUESDAY, JULY 8, 2025</h4>
           <div class="row g-3">
            <!-- Iteriere über flache Liste für Tag 2 -->
            <AgendaEntry v-for="ae in filteredListDay2" 
                         :key="`list-d2-${ae.objvalueid}`" 
                         :ae="ae"
                         agendatype="list"
                         class="col-md-6"/>
             <p v-if="filteredListDay2.length === 0" class="text-muted">No events found for this day based on current filters.</p>
          </div>
        </div>
      </div> <!-- Ende tablet-list-view -->

      <!-- NEU: Mobile Listenansicht -->
      <div class="mobile-list-view">
         <!-- Tagesübersicht für Montag (Liste) -->
        <div v-if="showDay1" class="day-section mb-4">
          <h4 class="font-weight-bold pb-3">MONDAY, JULY 7, 2025</h4>
          <div>
            <!-- Iteriere über flache Liste für Tag 1 -->
            <AgendaEntry v-for="ae in filteredListDay1" 
                         :key="`list-m-d1-${ae.objvalueid}`" 
                         :ae="ae"
                         agendatype="list" /> <!-- Volle Breite auf Mobile -->
            <p v-if="filteredListDay1.length === 0" class="text-muted">No events found for this day based on current filters.</p>
          </div>
        </div>
        <!-- Tagesübersicht für Dienstag (Liste) -->
         <div v-if="showDay2" class="day-section mb-4">
          <h4 class="font-weight-bold pb-3">TUESDAY, JULY 8, 2025</h4>
          <div>
            <!-- Iteriere über flache Liste für Tag 2 -->
            <AgendaEntry v-for="ae in filteredListDay2" 
                         :key="`list-m-d2-${ae.objvalueid}`" 
                         :ae="ae"
                         agendatype="list" />
             <p v-if="filteredListDay2.length === 0" class="text-muted">No events found for this day based on current filters.</p>
          </div>
        </div>
      </div> <!-- Ende mobile-list-view -->
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import Agenda from "@/components/Agenda.vue"
import AgendaEntry from "@/components/AgendaEntry.vue"
import { useGtm } from '@/composables/useGtm'
import type { AgendaPoint } from '@/store/i/types'
import {DateTime} from "luxon";

// Hilfsfunktion zur Style-Berechnung (width, right und box-sizing)
const getEventStyle = (ae: AgendaPoint, startHourTimeline: number) => {
  const startDate = DateTime.fromISO(ae.startdate, {zone: 'Europe/Berlin'});
  const endDate = DateTime.fromISO(ae.enddate, {zone: 'Europe/Berlin'});
  const startHour = startDate.hour;
  const startMinute = startDate.minute;
  const durationInMinutes = (endDate.toMillis() - startDate.toMillis()) / (1000 * 60);

  const slotHeight = 3; // 3rem pro 15 Minuten
  const minutesPerSlot = 15;
  const minutesSince8am = ((startHour - startHourTimeline) * 60) + startMinute;
  const top = (minutesSince8am / minutesPerSlot) * slotHeight;
  const calculatedHeight = (durationInMinutes / minutesPerSlot) * slotHeight;
  const minHeight = 2.5; 

  return {
    position: 'absolute' as const,
    boxSizing: 'border-box' as const,
    top: `${top}rem`,
    height: `${Math.max(calculatedHeight, minHeight)}rem`,
    left: '0.5rem', 
    right: '0.5rem',
    width: 'calc(100% - 1rem)',
    zIndex: 1
    // Weitere Styles werden durch CSS-Klassen in AgendaEntry gesteuert
  };
};

// NEU: Hilfsfunktion zur Style-Berechnung für Accordions (mit isOpen Flag für z-index)
const getAccordionStyle = (events: AgendaPoint[], isOpen: boolean, startHourTimeline: number) => {
  if (!events || events.length === 0) return {};
  // Nutze das erste Event der Gruppe für die Positionierung
  const firstEvent = events[0];
  if (!firstEvent) return {}; // Zusätzlicher Check
  const startDate = DateTime.fromISO(firstEvent.startdate, {zone: 'Europe/Berlin'});
  const startHour = startDate.hour;
  const startMinute = startDate.minute;

  const slotHeight = 3; // 3rem pro 15 Minuten
  const minutesPerSlot = 15;
  const minutesSince8am = ((startHour - startHourTimeline) * 60) + startMinute;
  const top = (minutesSince8am / minutesPerSlot) * slotHeight;
  
  return {
    position: 'absolute' as const,
    boxSizing: 'border-box' as const,
    top: `${top}rem`,
    left: '0.5rem', 
    right: '0.5rem',
    width: 'calc(100% - 1rem)',
    zIndex: isOpen ? 3 : 2 // Höherer z-index wenn offen
  };
};

// Hilfsfunktion zum Mappen von Eventtyp-ID zu Key (KORRIGIERT)
const getEventTypeKey = (typeId: number | string | undefined): string | null => {
    const map: Record<string | number, string> = {
        // Korrektes Mapping (wie in Agenda.vue)
        6: 'plenary_sessions',  
        7: 'breakout_sessions', 
        5: 'exhibitor_events',  
        4: 'networking'         
    };
    // Konvertiere zu Nummer, falls String übergeben wird
    const typeNumber = typeof typeId === 'string' ? parseInt(typeId, 10) : typeId;
    
    if (typeNumber === undefined || isNaN(typeNumber)) return null;
    
    return map[typeNumber] || null;
};

export default defineComponent({
  name: 'AgendaOverview',

  components: {
    Agenda,
    AgendaEntry
  },

  setup() {
    const store = useStore()
    const { trackPage } = useGtm()
    const searchtext = ref('')
    const activeFilters = ref({
      eventTypes: {} as Record<string, boolean>,
      days: { day1: true, day2: true }, // Start mit aktiven Tagen
      locations: {} as Record<string, boolean>
    })

    const locations = [
      'Bundeskunsthalle',
      'Kunstmuseum Bonn',
      'DW Headquarters',
    ]

    const createTimeSlots = (startHour: number, endHour: number) => {
      const slots: string[] = []
      for (let hour = startHour; hour < endHour; hour++) {
        for (let minute = 0; minute < 60; minute += 15) {
          slots.push(`${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`)
        }
      }
      return slots
    }

    // timeSlots generiert jetzt alle 15min Slots von 08:00 bis 19:45

    const getSlotTimesForDay = (events: Record<string, AgendaPoint[]>) => {
      let startdates: Date[] = [];
      let enddates: Date[] = [];

      for (const eventsforlocation in events) {
        if (events[eventsforlocation].length > 0) {
          startdates.push(
              new Date(events[eventsforlocation][0].startdate)
          );
          enddates.push(
              new Date(events[eventsforlocation][events[eventsforlocation].length - 1].enddate)
          );
        }
      }

      if (startdates.length === 0) {
        return createTimeSlots(8, 10);
      }

      const mindate = startdates.sort((a: Date, b: Date) => a.getTime() - b.getTime())[0];
      const maxdate = enddates.sort((a: Date, b: Date) => b.getTime() - a.getTime())[0];

      const starthour = Math.max(8, mindate.getHours());
      // wir hatten einen programmpunkt der auf auf 00 am nächsten tag endet, das muss ne 24 sein
      const endhour = Math.min(24, maxdate.getHours() === 0 ? 24 : (maxdate.getHours() + 1));

      return createTimeSlots(starthour, endhour);
    }

    const timeSlotsDay1 = computed(() => {
      return getSlotTimesForDay(filteredEventsDay1.value);
    });

    const timeSlotsDay2 = computed(() => {
      return getSlotTimesForDay(filteredEventsDay2.value);
    });

    const startHourTimelineDay1 = computed(() => {
      return Number(timeSlotsDay1.value[0].slice(0, 2));
    });

    const startHourTimelineDay2 = computed(() => {
      return Number(timeSlotsDay2.value[0].slice(0, 2));
    });

    const showDay1 = computed(() => activeFilters.value.days.day1)
    const showDay2 = computed(() => activeFilters.value.days.day2)

    const baseEvents = computed<AgendaPoint[]>(() => store.getters['i/orderedAgendaPoints']);

    // NEU: Computed Property für aktive Locations
    const activeLocations = computed(() => {
        return locations.filter(loc => activeFilters.value.locations[loc]);
    });

    // Angepasste Computed Property für gefilterte Events
    const filteredEventsComputed = computed(() => {
      const result: { [key: number]: { [key: string]: AgendaPoint[] } } = { 1: {}, 2: {} };
      const daysToProcess = [1, 2].filter(day => activeFilters.value.days[day === 1 ? 'day1' : 'day2']);
      
      for (const day of daysToProcess) {
          result[day] = {}; 
          for (const location of locations) { 
              let events = baseEvents.value;

              // Nach Tag filtern
              events = events.filter(event => {
                  const eventDate = new Date(event.startdate);
                  const eventDay = eventDate.getDate(); 
                  return (day === 1 && eventDay === 7) || (day === 2 && eventDay === 8);
              });

              // Nach Location filtern (nur Events für diese Spalte)
              events = events.filter(event => event.location === location);

              // Nach Suchtext filtern
              if (searchtext.value) {
                  const lowerSearch = searchtext.value.toLowerCase();
                  events = events.filter(
                      (ae) =>
                          ae.title?.toLowerCase().includes(lowerSearch) ||
                          ae.subtitle?.toLowerCase().includes(lowerSearch) ||
                          ae.hosted_by?.toLowerCase().includes(lowerSearch)
                  );
              }

              // Nach Eventtypen filtern (aus globalen Filtern)
              const activeEventTypeKeys = Object.keys(activeFilters.value.eventTypes).filter(key => activeFilters.value.eventTypes[key]);
              if (Object.keys(activeFilters.value.eventTypes).length > 0) {
                   if (activeEventTypeKeys.length === 0) {
                       events = []; 
                   } else {
                       events = events.filter(event => {
                           const typeKey = getEventTypeKey(event.eventtype); 
                           return typeKey ? activeEventTypeKeys.includes(typeKey) : false;
                       });
                   }
              } 

              // Events für diese Spalte nur hinzufügen, wenn der Location-Filter aktiv ist
              if (activeFilters.value.locations[location] !== false) { 
                  result[day][location] = events;
              } else {
                  result[day][location] = []; 
              }
          }
      }
      return result;
    });
    
    // Separate computed properties für einfachen Zugriff im Template
    const filteredEventsDay1 = computed(() => filteredEventsComputed.value[1] || {});
    const filteredEventsDay2 = computed(() => filteredEventsComputed.value[2] || {});

    // NEU: Gruppierte Events für Accordion
    const groupedFilteredEventsDay1 = computed(() => {
      const grouped: { [location: string]: { [time: string]: AgendaPoint[] } } = {};
      // Initialisiere für alle *potentiellen* Locations, um Fehler zu vermeiden, falls Location-Filter aktiv ist
      locations.forEach(loc => grouped[loc] = {}); 

      Object.entries(filteredEventsDay1.value).forEach(([location, events]) => {
          if (!grouped[location]) grouped[location] = {}; // Sicherheitshalber
          events.forEach(event => {
              // Verwende HH:MM Format für den Key
              const startDate = DateTime.fromISO(event.startdate, {zone: 'Europe/Berlin'});
              const hours = startDate.hour.toString().padStart(2, '0');
              const minutes = startDate.minute.toString().padStart(2, '0');
              const startTime = `${hours}:${minutes}`;
              if (!grouped[location][startTime]) {
                  grouped[location][startTime] = [];
              }
              grouped[location][startTime].push(event);
          });
           // Sortiere Events innerhalb jeder Zeitgruppe (optional, z.B. nach Titel)
           Object.values(grouped[location]).forEach(timeGroup => {
               timeGroup.sort((a, b) => (a.title ?? '').localeCompare(b.title ?? ''));
           });
      });
      return grouped;
    });

    const groupedFilteredEventsDay2 = computed(() => {
      const grouped: { [location: string]: { [time: string]: AgendaPoint[] } } = {};
       locations.forEach(loc => grouped[loc] = {}); // Initialisieren

      Object.entries(filteredEventsDay2.value).forEach(([location, events]) => {
          if (!grouped[location]) grouped[location] = {}; // Sicherheitshalber
          events.forEach(event => {
               // Verwende HH:MM Format für den Key
              const startDate = DateTime.fromISO(event.startdate, {zone: 'Europe/Berlin'});
              const hours = startDate.hour.toString().padStart(2, '0');
              const minutes = startDate.minute.toString().padStart(2, '0');
              const startTime = `${hours}:${minutes}`;
              if (!grouped[location][startTime]) {
                  grouped[location][startTime] = [];
              }
              grouped[location][startTime].push(event);
          });
          // Sortiere Events innerhalb jeder Zeitgruppe (optional)
           Object.values(grouped[location]).forEach(timeGroup => {
               timeGroup.sort((a, b) => (a.title ?? '').localeCompare(b.title ?? ''));
           });
      });
      return grouped;
    });

    // Angepasster Grid Style (nur aktive Spalten)
    const gridStyle = computed(() => {
        const activeLocationCount = activeLocations.value.length; // NEU: Nutze activeLocations
        // Definiert Spalten: Linke Timeline, N aktive Location-Spalten, Rechte Timeline
        // Feste Breite (z.B. 60px) für Timelines, Rest flexibel
        const cols = activeLocationCount > 0 ? `60px repeat(${activeLocationCount}, minmax(0, 1fr)) 60px` : '60px 1fr 60px'; 
        return { gridTemplateColumns: cols };
    });
    
    // NEU: Computed Property für gefilterte flache Liste (alle Filter angewendet)
    const filteredEventsListComputed = computed(() => {
      let events = baseEvents.value;

      // Nach Tagen filtern (nur aktive Tage behalten)
      const daysActive = {
        day1: activeFilters.value.days.day1,
        day2: activeFilters.value.days.day2
      };
      if (!daysActive.day1 && !daysActive.day2) return []; // Nichts anzeigen, wenn beide Tage aus sind
      events = events.filter(event => {
        const eventDate = new Date(event.startdate);
        const eventDay = eventDate.getDate(); // 7 oder 8
        return (daysActive.day1 && eventDay === 7) || (daysActive.day2 && eventDay === 8);
      });

      // Nach Suchtext filtern
      if (searchtext.value) {
          const lowerSearch = searchtext.value.toLowerCase();
          events = events.filter(
              (ae) =>
                  ae.title?.toLowerCase().includes(lowerSearch) ||
                  ae.subtitle?.toLowerCase().includes(lowerSearch) ||
                  ae.hosted_by?.toLowerCase().includes(lowerSearch)
          );
      }

      // Nach Eventtypen filtern
      const activeEventTypeKeys = Object.keys(activeFilters.value.eventTypes).filter(key => activeFilters.value.eventTypes[key]);
      if (Object.keys(activeFilters.value.eventTypes).length > 0) { // Nur filtern, wenn Filteroptionen da sind
          if (activeEventTypeKeys.length === 0) {
              events = []; // Keine Events, wenn kein Typ ausgewählt
          } else {
              events = events.filter(event => {
                  const typeKey = getEventTypeKey(event.eventtype); 
                  return typeKey ? activeEventTypeKeys.includes(typeKey) : false;
              });
          }
      } 

      // Nach aktivierten Locations filtern 
      const activeLocationFilters = Object.keys(activeFilters.value.locations).filter(key => activeFilters.value.locations[key]);
      if (Object.keys(activeFilters.value.locations).length > 0) { // Nur filtern, wenn Filteroptionen da sind
           if (activeLocationFilters.length === 0) {
               events = []; // Keine Events, wenn keine Location ausgewählt
           } else {
              events = events.filter(event => event.location && activeLocationFilters.includes(event.location));
           }
      }

      // Optional: Sortieren nach Startzeit (sollte durch orderedAgendaPoints schon geschehen, aber zur Sicherheit)
      events.sort((a, b) => new Date(a.startdate).getTime() - new Date(b.startdate).getTime());

      return events;
    });

    // NEU: Computed Properties für die Listenansicht pro Tag
    const filteredListDay1 = computed(() => {
      return filteredEventsListComputed.value.filter(event => new Date(event.startdate).getDate() === 7);
    });
    const filteredListDay2 = computed(() => {
      return filteredEventsListComputed.value.filter(event => new Date(event.startdate).getDate() === 8);
    });

    // NEU: Ref für aktuell geöffnetes Accordion
    const currentlyOpenAccordionId = ref<string | null>(null);

    // NEU: Methode zum Öffnen/Schließen eines Accordions
    const toggleAccordion = (accordionId: string) => {
        if (currentlyOpenAccordionId.value === accordionId) {
            currentlyOpenAccordionId.value = null; // Schließen, wenn bereits offen
        } else {
            currentlyOpenAccordionId.value = accordionId; // Öffnen (schließt andere automatisch)
        }
    };

    onMounted(() => {
       // Initialisierung der Location-Filter, falls noch nicht geschehen
      if (Object.keys(activeFilters.value.locations).length === 0 && locations.length > 0) {
          locations.forEach(loc => {
              if (activeFilters.value.locations[loc] === undefined) {
                 activeFilters.value.locations[loc] = true; // Default: aktiv
              }
          });
      }
      
      trackPage({
        pageCategory: 'Program',
        PageName: 'Overview',
        PageType: 'Webapp',
      })
    })

    return {
      searchtext,
      activeFilters,
      timeSlotsDay1,
      timeSlotsDay2,
      startHourTimelineDay1,
      startHourTimelineDay2,
      showDay1,
      showDay2,
      locations, // Feste Liste für Spaltenstruktur (falls noch gebraucht)
      activeLocations, // NEU
      gridStyle, // Style für das äußere Grid (jetzt fix)
      filteredEventsDay1,
      filteredEventsDay2,
      groupedFilteredEventsDay1, // NEU
      groupedFilteredEventsDay2, // NEU
      getEventStyle,
      getAccordionStyle, // NEU
      filteredListDay1, // NEU
      filteredListDay2,  // NEU
      currentlyOpenAccordionId, // NEU
      toggleAccordion // NEU
    }
  }
})
</script>

<style scoped>
.filter-section {
  width: 100%;
  padding: 1.5rem 0;
}

.filter-agenda {
  width: 100%;
}

/* Grid für die Überschriften */
.location-header-grid {
  display: grid;
  /* grid-template-columns wird jetzt per Style gesetzt */
  gap: 1rem; /* Abstand zwischen Spalten (könnte kleiner sein?) */
  width: 100%;
  margin-bottom: 0.5rem;
  padding: 0; /* Ggf. Padding anpassen */
}

.location-header-grid h4 {
  text-align: center;
  font-weight: bold;
  margin-bottom: 0;
  padding: 0.5rem 0;
  border-bottom: 1px solid #dee2e6; /* Linie unter Überschrift */
  white-space: nowrap; /* Verhindert Umbruch */
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Abstandshalter für Zeitskala-Spalten in der Header-Grid */
.time-header-spacer {
  width: 60px; /* Breite der Zeitskala */
  border-bottom: 1px solid #dee2e6; /* Linie passend zu H4 */
}

/* Haupt-Grid für Timeline und Inhalte */
.timeline-grid {
  display: grid;
  /* grid-template-columns wird jetzt per Style gesetzt */
  gap: 1rem;
  width: 100%;
  position: relative;
}

/* Container für die Location-Spalten (subgrid oder alternative Platzierung) */
.location-columns-container {
  grid-column: 2 / -2; 
  grid-row: 1 / -1; 
  display: grid;
  /* grid-template-columns: subgrid; // Beibehalten, falls es funktioniert */
  /* Alternative, falls subgrid nicht geht: Keine explizite Spaltendefinition hier */
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr)); /* Fallback, falls Subgrid nicht greift? Eher weglassen. */
  gap: 1rem; 
  height: 100%;
  position: relative;
}

/* Die .location-column Elemente */
.location-column {
   /* Sie sollten sich automatisch in die Tracks des Containers einfügen */
   /* Keine explizite grid-column Zuweisung mehr? DOCH, durch location-columns-container subgrid */
   grid-row: 1 / -1; /* Spannt über die Höhe */
   position: relative; 
   height: 100%; /* Oder min-height? */
   border-left: 1px solid var(--bs-gray-200);
}
/* Korrektur: Muss relativ zum parent container sein */
.location-columns-container > .location-column:first-of-type {
    border-left: none; 
}

/* Container für Events innerhalb einer Location-Spalte */
.events-container {
  position: absolute; /* Damit Events darin absolut positioniert werden können */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* padding: 0 0.5rem; Optional: Padding für Events von den Rändern */
}

/* Timeline Styling (Anpassung für Grid-Platzierung) */
.timeline {
  display: flex;
  flex-direction: column;
  height: 100%;
  grid-row: 1 / -1; /* Spannt über alle Zeilen */
}
.timeline-grid > .timeline:first-of-type {
   grid-column: 1 / 2;
}
.timeline-grid > .timeline:last-of-type {
   grid-column: -2 / -1; /* Letzte Spalte */
}

.time-slot {
  height: 3rem; /* 15 Minuten Höhe */
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding-top: 0.1rem;
  padding-right: 0.5rem;
  font-size: 0.7rem; /* Kleinere Schrift für alle Slots */
  color: var(--bs-gray-600);
  border-bottom: 1px solid var(--bs-gray-300); /* Einheitliche, dezente Linie */
  box-sizing: border-box;
}

.time-slot:last-of-type {
  border-bottom: none; /* Letzte Linie entfernen */
}

.day-section {
  padding-bottom: 2rem;
}

/* Responsive Anpassungen müssen ggf. auch gridStyle berücksichtigen */
@media (max-width: 992px) {
   /* Header Grid */
   .location-header-grid {
       /* Style wird dynamisch gesetzt, evtl. Anpassung der Spaltenzahl hier? */
       /* Besser: gridStyle computed property passt sich an */
       grid-template-columns: 3rem repeat(var(--active-location-count, 3), minmax(0, 1fr)); /* Rechte Spacer weg, Anzahl dynamisch */
       /* --active-location-count müsste per JS gesetzt werden oder fix? Kompliziert */
   }
    /* ... Header Spacer anpassen ... */

   /* Timeline Grid */
  .timeline-grid {
    /* Style wird dynamisch gesetzt */
    grid-template-columns: 3rem 1fr; /* Feste Annahme: Rechte Timeline ist weg */
  }
   .timeline:last-of-type {
      display: none;
  }
   /* Location Container */
  .location-columns-container {
      grid-column: 2 / 3; 
      grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr)); /* Mind. 16rem breit */
      overflow-x: auto; 
      padding-bottom: 1rem; 
      display: grid; 
      gap: 1rem; 
      height: 100%;
      position: relative;
  }
  /* .location-column Styles bleiben unverändert */
   .location-column {
       position: relative;
       height: 100%;
       border-left: 1px solid var(--bs-gray-200);
  }
  .location-column:first-child {
      border-left: none; 
  }

  /* NEU: Breite der Timeline-Karten explizit anpassen für Tablets */
  /* Wir sprechen das Wrapper-Element an, das die Inline-Styles erhält */
  .location-column .timeline-card-wrapper {
      left: 2% !important;   /* Inline-Style 'left' überschreiben */
      right: 2% !important;  /* Inline-Style 'right' überschreiben */
      width: 96% !important; /* Inline-Style 'width' überschreiben */
      /* Höhe und Top kommen weiterhin aus dem Inline-Style */
  }

   /* ... Rest Tablet ... */
}

@media (max-width: 576px) {
     /* Header Grid */
   .location-header-grid {
       grid-template-columns: 1fr;
   }
   /* ... Header Rest ... */
    /* Timeline Grid */
    .timeline-grid {
        grid-template-columns: 1fr; 
    }
    .timeline {
        display: none;
    }
     /* Location Container */
     .location-columns-container {
      grid-template-columns: 1fr;
      grid-column: 1 / -1;
      overflow-x: visible; 
    }
   /* ... Rest Mobile ... */
}

/* Standardmäßig Tablet/Mobile Ansichten ausblenden */
.tablet-list-view,
.mobile-list-view {
  display: none;
}

/* Desktop: Nur Timeline anzeigen */
@media (min-width: 992.01px) {
  .desktop-timeline-view {
    display: block; /* Oder was immer der Standard war */
  }
  .tablet-list-view,
  .mobile-list-view {
    display: none !important; /* Wichtig, um andere Regeln zu überschreiben */
  }
}

/* Tablet: Nur Tablet-Liste anzeigen */
@media (max-width: 992px) {
  .desktop-timeline-view {
    display: none;
  }
  .tablet-list-view {
    display: block; /* Oder flex, je nach gewünschtem Innenlayout */
  }
  .mobile-list-view {
    display: none;
  }
  /* Zusätzliche Styles für Tablet-Liste (z.B. .row > .col-md-6) hier */
}

/* Mobile: Nur Mobile-Liste anzeigen */
@media (max-width: 576px) {
  .desktop-timeline-view, 
  .tablet-list-view {
    display: none;
  }
  .mobile-list-view {
    display: block;
  }
   /* Ggf. Styles für Mobile-Liste hier */
}

/* Bestehende Media Queries für Timeline anpassen/entfernen, falls sie stören */
/* Z.B. die Tablet/Mobile Anpassungen für .timeline-grid etc. sind nicht mehr nötig */
@media (max-width: 992px) {
  /* ENTFERNT/AUSKOMMENTIERT: Anpassungen für das Timeline-Grid, da es hier nicht sichtbar ist */
  /* .location-header-grid { ... } */
  /* .timeline-grid { ... } */
  /* .timeline:last-of-type { display: none; } */
  /* .location-columns-container { ... } */
  /* .location-column .timeline-card-wrapper { ... } */
}
@media (max-width: 576px) {
   /* ENTFERNT/AUSKOMMENTIERT: Anpassungen für das Timeline-Grid */
  /* .location-header-grid { ... } */
  /* .timeline-grid { ... } */
  /* .timeline { display: none; } */
  /* .location-columns-container { ... } */
}

/* NEU: Styles für Accordion in Timeline */
.timeline-accordion .accordion-item {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  margin-bottom: 0.2rem; /* Kleiner Abstand zwischen Accordions übereinander */
  background-color: #fff; /* Hintergrund für Accordion Item */
}
.timeline-accordion .accordion-button {
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem; /* Etwas kleiner */
  font-weight: bold;
  background-color: #f8f9fa; /* Heller Hintergrund für Header */
  border: none;
  box-shadow: none;
  width: 100%;
  text-align: left;
}
.timeline-accordion .accordion-button:not(.collapsed) {
  color: var(--bs-primary); /* Passend zum Theme */
  background-color: #e7f1ff; /* Leichter Blauton */
}
.timeline-accordion .accordion-button::after {
  /* Standard Bootstrap Pfeil, evtl. anpassen */
  font-size: 0.9rem; 
}

.timeline-accordion .accordion-body {
  padding: 0.5rem; /* Weniger Padding im Body */
}

/* Styling für AgendaEntry INNERHALB des Accordions */
/* WICHTIG: Entfernt absolute Positionierung */
.timeline-accordion .accordion-body .agenda-entry {
   margin-bottom: 0.5rem;
   position: static !important; 
   width: 100% !important;
   height: auto !important; 
   top: auto !important;
   left: auto !important;
   right: auto !important;
   z-index: auto !important;
   border: 1px solid #eee; /* Optional: Leichter Rahmen für Unterscheidung */
   padding: 0.5rem; /* Innenabstand */
   box-shadow: none; /* Keinen Schatten */
}
.timeline-accordion .accordion-body .agenda-entry:last-child {
   margin-bottom: 0; /* Kein Abstand beim letzten Element */
}
</style>
